import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { appStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useYardSetupMessageHandler } from '../../hooks/useYardSetupMessageHandler'
import { IBerthFormData } from '../../models/yard-setup.model'
import { BerthViewStore } from '../../stores/nodes/berth.view-store'
import { BerthForm } from './BerthForm'

interface Props {
  berthViewStore: BerthViewStore
}

export const BerthDialogs = observer(({ berthViewStore }: Props) => {
  const { t } = useTranslate()
  const { getBerthSuccessMessage, getBerthDeleteSuccessMessage, getExceptionMessage } =
    useYardSetupMessageHandler()

  const onSubmit = async (data: IBerthFormData) => {
    try {
      await berthViewStore.submit(data)
      appStore.setShowAlert('success', getBerthSuccessMessage(!!berthViewStore.focusedBerth))
      berthViewStore.closeFormDialog()
    } catch (e: any) {
      appStore.setShowAlert('error', getExceptionMessage(e))
    }
  }

  const onDelete = async () => {
    try {
      await berthViewStore.delete(berthViewStore.editingId!)
      appStore.setShowAlert('success', getBerthDeleteSuccessMessage())
      berthViewStore.setDeleteDialogOpen()
    } catch (e: any) {
      appStore.setShowAlert('error', getExceptionMessage(e))
    }
  }

  return (
    <>
      <ConfirmationDialog
        open={berthViewStore.isFormDialogOpen}
        title={
          berthViewStore.focusedBerth ? t('editBerth', 'Edit berth') : t('addBerth', 'Add berth')
        }
        primaryActionText={
          berthViewStore.focusedBerth
            ? t('yesUpdate', 'Yes, update')
            : t('yesCreate', 'Yes, create')
        }
        closeLabel={t('noCancel', 'No, cancel')}
        formId='berth-form'
        onClose={() => berthViewStore.closeFormDialog()}
      >
        <BerthForm
          id='berth-form'
          berth={berthViewStore.focusedBerth}
          piers={berthViewStore.piers}
          onSubmit={onSubmit}
        />
      </ConfirmationDialog>

      <ConfirmationDialog
        open={berthViewStore.isDeleteDialogOpen}
        title={t('deleteBerth', 'Delete berth')}
        message={t('youCannotUndoThisAction', 'You cannot undo this action.')}
        primaryActionText={t('yesDelete', 'Yes, delete')}
        closeLabel={t('noCancel', 'No, cancel')}
        onClose={() => berthViewStore.setDeleteDialogOpen()}
        onConfirm={onDelete}
        maxWidth='xs'
      />
    </>
  )
})
